export const URL_CLASH_ERROR_CODE = '201';
export const INLINE_PLAYER_CLASH_ERROR_CODE = '202';

export const errorCodeList = [
    URL_CLASH_ERROR_CODE,
    INLINE_PLAYER_CLASH_ERROR_CODE,
] as const;

export type ApiErrorCode = (typeof errorCodeList)[number];
